<template>
	<div>
		<!-- 近期活动 -->
		<div class="expert">
			<Breadcrumb></Breadcrumb>
			<div class="pad-16 col-22 boxshow"
				v-show="$route.meta.showFather&& this.$route.fullPath =='/activity/index'">
				<div class="flex-1 wid-100" style="margin-bottom: 24px;cursor: pointer;"
					v-for="(item,index) in expertList" :key="index" @click="detail(item.id)">
					<div class="tttile">
						<img :src="item.coverImage" alt="" class="hed-img">
						<!-- <p class="first">待开始</p> -->
						<p class="first"
							:class="item.activityStatus=='1000'?'first-1':item.activityStatus=='2000'?'first-2':'first-3'">
							{{item.activityStatus=='1000'?'待开始':item.activityStatus=='2000'?'进行中':'已结束'}}
						</p>
						<!-- item.activityStatus -->
					</div>
					<div class="wid-100" style="padding-right: 48px;">
						<div class="flex-1 just-bet mb-8">
							<p class="name-1">{{item.name}}</p>
						</div>
						<div class="flex-1 just-bet mb-8" style="align-items: baseline;">
							<p class="name-2">培训简介:</p>
							<p class="name-3">
								{{item.intro}}
							</p>
						</div>
						<div class="flex-1 just-bet" style="margin-bottom: 22px;">
							<p class="name-2">培训时间:</p>
							<p class="name-3">
								{{utils.getNowTime(item.startTime)}}-{{utils.getNowTimes(item.endTime)}}
							</p>
						</div>
					</div>
					<div class="mt-23">
						<p class="mon-1">¥&nbsp;{{item.price}}</p>
						<!-- <div :class="!item.eventStatus&&item.activityStatus!='3000'?'online':'online-1'" v-if="!item.eventStatus&&item.activityStatus!=3000">
							立即报名
						</div> -->
						<div class="online" v-if="!item.eventStatus&&item.activityStatus<3000">
							立即报名
						</div>
						<div class="online" v-if="item.eventStatus">
							已报名
						</div>
					</div>
				</div>
				<el-pagination v-show="pageInline.tableTotal>0" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :page-sizes="pageGroup.sizes" :page-size="pageGroup.size"
					layout="total, sizes, prev, pager, next, jumper" :total="pageInline.tableTotal">
				</el-pagination>
			</div>
			<router-view />
		</div>
		<footers v-show="footersType==0"></footers>
	</div>
</template>

<script>
	import Breadcrumb from '@/views/Breadcrumb.vue';
	import footers from '@/views/footers.vue';
	import {
		getActivity,
	} from '@/api/activity/api.js';
	export default {
		components: {
			Breadcrumb,
			footers
		},
		data() {
			return {
				expertList: [],
				page: 1,
				limit: this.pageGroup.size,
				//分页对象
				pageInline: {
					tableSizes: this.pageGroup.sizes, //显示条数分组
					tableTotal: 10, // 默认数据总数
				},
				seachType: '',
				name: '',
				footersType: 0,
			}
		},
		watch: {
			'$root.searchText'(val) {
				this.name = val;
				this.getInit();
			}
		},
		created() {

		},
		mounted() {
			this.footersType = this.$route.query.footersType || 0;
			this.seachType = this.$route.params.seachType;
			this.name = this.$route.params.title;
			this.getInit();
		},
		methods: {
			getInit() {
				let params = {
					pageNo: this.page,
					pageSize: this.pageGroup.size,
					name: this.name,
				}
				getActivity(params).then(res => {
						this.expertList = res.data.list;
						this.pageInline.tableTotal = res.data.total;
					})
					.catch(error => {

					});
			},
			//页容量改变时会触发
			handleSizeChange(size) {
				this.limit = size;
				this.getInit();
			},
			//当前页改变时会触发
			handleCurrentChange(currentPage) {
				console.log(currentPage, 'currentPage')
				this.page = currentPage;
				this.getInit();
			},
			detail(id) {
				this.$router.push({
					name: 'activityDetail',
					params: {
						id: id
					}
				})
			}
		}
	}
</script>

<style scoped>
	.expert {
		padding: 0 19%;

		/* margin-bottom: 100px; */
	}

	.pad-16 {
		padding: 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
		/* justify-content: space-between; */
	}


	.jus-bet {
		justify-content: space-between;
	}

	.align-1 {
		align-items: center;
	}

	.col-22 {
		color: #222222;

	}

	.tttile {
		position: relative;
	}

	.hed-img {
		width: 288px;
		height: 173px;
		margin-right: 16px;
		border-radius: 8px;
	}

	.mb-8 {
		margin-bottom: 8px;
	}

	.name-1 {
		font-size: 20px;
		padding-right: 9px;
		padding-top: 35px;
	}

	.name-2 {
		color: #999999;
		font-size: 14px;
		white-space: nowrap;
		padding-right: 8px;
	}

	.name-3 {
		font-size: 14px;
		font-weight: normal;
	}

	/deep/.el-pagination {
		text-align: center;
	}

	.footers {
		margin-top: 25px !important;
	}

	.online {
		font-size: 14px;
		color: #3377FF;
		padding: 8px 16px;
		background: #F0F5FF;
		white-space: nowrap;
		border-radius: 35px 35px 35px 35px;
	}

	.online-1 {
		font-size: 14px;
		color: #ffffff;
		padding: 8px 16px;
		background: #ffffff;
		white-space: nowrap;
		border-radius: 35px 35px 35px 35px;
	}


	.mon-1 {
		font-size: 20px;
		color: #FF5533;
		padding-bottom: 50px;
	}

	.mt-23 {
		margin-top: 23px;
		text-align: center;
	}

	.first {
		font-size: 14px;
		font-weight: normal;
		/* line-height: 21px; */
		position: absolute;
		left: 0;
		top: 0;
		border-radius: 4px 16px 4px 16px;
		padding: 4px 16px;
	}

	.first-1 {
		color: #FBB54C;
		background: #FFF6F0;
	}

	.first-2 {
		color: #3ECC64;
		background: #EBFAEF;
	}

	.first-3 {
		color: #FF534D;
		background: #FFF0F0;
	}

	.boxshow {
		box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
		margin-top: 16px;
	}
</style>